import React, { useContext } from "react";

import FileCopyIcon from "@mui/icons-material/FileCopy";
import { Box, Button, Portal, Snackbar, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import MealPlanFormStore from "../store/MealPlanFormStore";

const useStyles = makeStyles()((theme) => ({
  snackbar: {
    "& .MuiSnackbarContent-root": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.common.black,
    },
  },
}));

const ClipboardSnackbar: React.FC = observer(() => {
  const { classes } = useStyles();

  const store = useContext(MealPlanFormStore.Context);
  const clipboard = store.clipboard;
  const activeCell = store.cells.active;

  function handleClose() {
    clipboard.clear();
  }

  function handlePaste() {
    if (activeCell) clipboard.pasteCell(activeCell);
  }

  return (
    <Portal>
      <Snackbar
        className={classes.snackbar}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={clipboard.isCopying}
        message={
          <Box display="flex" alignItems="center">
            <FileCopyIcon fontSize="small" color="secondary" />
            <Box marginRight={2} />
            <Typography>{clipboard.label}</Typography>
          </Box>
        }
        action={
          <>
            <Button variant="text" size="small" onClick={handleClose}>
              Clear
            </Button>
            {clipboard.mode === "cell" && (
              <Button
                color="primary"
                variant="text"
                size="small"
                onClick={handlePaste}
              >
                Paste
              </Button>
            )}
          </>
        }
      />
    </Portal>
  );
});

export default ClipboardSnackbar;
